<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center
            >Freight WareHouse Execution
            <small class="ml-2"
              ><b-badge variant="info">{{
                ffExportDetail.portType == "Icd"
                  ? " Stuffing At ICD"
                  : " Stuffing At PORT (Port Stuffing)"
              }}</b-badge></small
            >
          </b-navbar-brand>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="ALLMODULE"
          :jobSeriesBanner="JOBSERIES"
          :bannerClientName="mainEntryData.length > 0 ? mainEntryData[0].clientName : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div v-if="newContainerFlow == '1'">
              <b-button size="sm" class="pull-right" @click="showDocModal" variant="dark"
                >Upload Documents</b-button
              >
              <container-component
                v-if="ALLMODULE"
                :allModuleIdContainer="ALLMODULE"
                JOB="FF"
              />
            </div>
            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>WareHouse Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="nameOfCFS"
                    id="nameOfCFS"
                    v-model="WarehouseStuffing.nameOfCFS"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!WarehouseStuffing.nameOfCFS">{{
                  nameOfCFSError
                }}</span>
              </md-layout>
            </md-layout>
            <div v-if="newContainerFlow == '0'">
              <div>
                <div class="mt-3">
                  <!-- <b-button size="sm"   @click="showDocModal" variant="dark">Upload SB Documents</b-button> -->
                </div>
                <md-layout
                  md-gutter
                  class="gutr mt-4"
                  v-if="getContainerList.length == 0"
                >
                  <md-layout md-flex="100">
                    <b-button size="sm" variant="outline-dark" @click="showMoreSBDet"
                      >{{ showMoreSB == true ? "Hide" : "Add" }} Shipping Bill
                      Details</b-button
                    >
                    <md-spinner
                      md-indeterminate
                      id="loader1"
                      style="display: none"
                    ></md-spinner>
                    <b-button
                      size="sm"
                      class="ml-2"
                      @click="showDocModal"
                      variant="outline-dark"
                      >Upload SB Documents</b-button
                    >
                  </md-layout>
                </md-layout>

                <b-card
                  class="mt-3"
                  style="background: whiteSmoke"
                  v-if="
                    getContainerList.length > 0 ||
                    SBDetail.shippingSBId != '' ||
                    showMoreSB
                  "
                >
                  <div
                    v-if="
                      getContainerList.length > 0 ||
                      SBDetail.shippingSBId != '' ||
                      showMoreSB
                    "
                  >
                    <!-- <md-layout md-gutter style="margin-top:1%">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="95">
                        <label>
                          <b>
                            <u>
                              Shipping Details
                              <span
                                class="error"
                                v-if="sbDetailArrayList.length==0"
                              >{{errorAtleastSb}}</span>
                            </u>
                          </b>
                        </label>
                      </md-layout>
                    </md-layout> -->
                    <md-layout gutter>
                      <!-- <md-layout md-flex="45">
                        <md-input-container>
                          <label> Invoice From Shipper</label>
                          <md-file
                            name="invoiceUpload"
                            id="invoiceUpload"
                            v-model="SBDetail.invoiceUpload"
                            @selected="onFileChange('Invoice')"
                            multiple
                          ></md-file>
                        </md-input-container>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout> -->

                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Shipper Invoice No.</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="shippingInvoiceNo"
                            id="shippingInvoiceNo"
                            v-model="SBDetail.shippingInvoiceNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>Invoice Date.</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          name="shippingBillDate"
                          id="shippingBillDate"
                          v-model="SBDetail.shippingInvoiceDate"
                          :minute-step="1"
                        ></date-picker>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter>
                      <div v-if="viewInvoicedDoc.length > 0">
                        <md-layout
                          md-flex="20"
                          v-for="(item, index) in viewInvoicedDoc"
                          :key="index"
                        >
                          <!-- :href="'http://13.229.240.246/FFExecutionSBWareHouse/'+item" -->
                          <a
                            :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                            target="_blank"
                            download
                            >View Document - {{ index + 1 }}</a
                          >
                        </md-layout>
                      </div>
                    </md-layout>
                    <md-layout md-gutter>
                      <!-- <md-layout md-flex="45">
                        <md-input-container>
                          <label> Cargo Packing List</label>
                          <md-file
                           
                            name="cargoUpload"
                            id="cargoUpload"
                            v-model="SBDetail.cargoUpload"
                            @selected="onFileChange('Cargo')"
                            multiple
                          ></md-file>
                        </md-input-container>
                      </md-layout> -->
                      <!-- <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="50">
                        <md-input-container>
                          <label> Shipping Bill Documents</label>
                          <md-file
                          
                            name="cargoUpload"
                            id="cargoUpload"
                            v-model="SBDetail.shippingBillUpload"
                            @selected="onFileChange('Shipping')"
                            multiple
                          ></md-file>
                        </md-input-container>
                      </md-layout> -->
                    </md-layout>

                    <md-layout md-gutter>
                      <div v-if="viewCargoDoc.length > 0">
                        <md-layout
                          md-flex="30"
                          v-for="(item, index) in viewCargoDoc"
                          :key="index"
                        >
                          <!-- :href="'http://13.229.240.246/FFExecutionSBWareHouse/'+item" -->
                          <a
                            :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                            target="_blank"
                            download
                            >View Document - {{ index + 1 }}</a
                          >
                        </md-layout>
                      </div>
                      <md-layout md-flex="40"></md-layout>
                      <div v-if="viewShippingdDoc.length > 0">
                        <md-layout
                          md-flex="30"
                          v-for="(item, index) in viewShippingdDoc"
                          :key="index"
                        >
                          <a
                            :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                            target="_blank"
                            download
                            >View Document - {{ index + 1 }}</a
                          >
                        </md-layout>
                      </div>
                    </md-layout>

                    <md-layout md-gutter class="gutr">
                      <md-layout md-flex="15">
                        <label>Shipping Bill Date *</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          name="shippingBillDate"
                          id="shippingBillDate"
                          v-model="SBDetail.shippingBillDate"
                          :minute-step="1"
                        ></date-picker>
                        <span class="error" v-if="!SBDetail.shippingBillDate">{{
                          errorSBExecution.shippingBillDate
                        }}</span>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="40">
                        <md-layout md-flex="100">
                          <label>Shipping Bill No. *</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="shippingBillNo"
                            id="shippingBillNo"
                            v-model="SBDetail.shippingBillNo"
                          ></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!SBDetail.shippingBillNo">{{
                          errorSBExecution.shippingBillNo
                        }}</span>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="35">
                        <md-layout md-flex="100">
                          <label>Cargo Gross Weight(KGS) *</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="cargoGrossWeight"
                            type="number"
                            min="0"
                            id="cargoGrossWeight"
                            v-model="SBDetail.cargoGrossWeight"
                          ></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!SBDetail.cargoGrossWeight">{{
                          errorSBExecution.cargoGrossWeight
                        }}</span>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter class="gutr">
                      <md-layout md-flex="15">
                        <label>Carting Date</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          name="cartingDate"
                          id="cartingDate"
                          v-model="SBDetail.cartingDate"
                          :minute-step="1"
                        ></date-picker>
                        <!-- <span
                  class="error"
                  v-if="!WarehouseStuffing.cartingDate"
                        >{{errorExecution.cartingDate}}</span>-->
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="40">
                        <md-layout md-flex="100">
                          <label>CRN ( Carting Order)</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="crnNumber"
                            id="crnNumber"
                            v-model="SBDetail.crnNumber"
                          ></b-form-input>
                        </md-layout>
                        <!-- <span class="error" v-if="!WarehouseStuffing.crnNumber">{{errorExecution.crnNumber}}</span> -->
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <b-button
                          variant="info"
                          size="sm"
                          style="margin-top: 40px"
                          id="addButtonLoaderSB"
                          @click="addSBDetail"
                          >{{ SBDetail.shippingSBId == "" ? "Add " : "Edit" }} Shipping
                          Bill</b-button
                        >
                        <md-spinner
                          md-indeterminate
                          id="loaderSB"
                          style="display: none"
                        ></md-spinner>
                      </md-layout>
                    </md-layout>
                  </div>
                </b-card>
              </div>

              <div class="mt-3" v-if="sbDetailArrayList.length > 0">
                <div>
                  <h5>
                    <b-badge>Shipping Bill Details</b-badge>
                  </h5>
                </div>

                <!-- /.box-header -->
                <div>
                  <table id="SBDetailr" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Shipper Invoice No</th>
                        <th>Shipping Bill No</th>
                        <th>Cargo Gross Weight</th>

                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in sbDetailArrayList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.shippingInvoiceNo }}</td>
                        <td>{{ item.shippingBillNo }}</td>
                        <td>{{ item.cargoGrossWeight }}</td>

                        <td>
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="viewEditSB(item.shippingSBId, index)"
                          >
                            <md-icon>edit</md-icon>
                          </md-button>
                        </td>
                        <td>
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="DeleteListSb(item.shippingSBId, index)"
                          >
                            <md-icon>delete_sweep</md-icon>
                          </md-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>

              <div>
                <!-- *******************************  Start  WareHouse  Warehouse Stuffing At ICD *****************************-->
                <div class="mt-3" v-if="containerTypeDetailFactoryList.length > 0">
                  <div>
                    <h5>
                      <b-badge>Container Details</b-badge>
                    </h5>
                  </div>

                  <!-- /.box-header -->
                  <div>
                    <table id="ffContainer" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr No.</th>

                          <th>Container No.</th>

                          <th>Container Type</th>
                          <th>Custom Seal No.</th>
                          <th>Line Seal No.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in containerTypeDetailFactoryList"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td
                            @click="viewEdit(item.ffExecutionContainerId, index)"
                            class="showMoreData"
                          >
                            {{ item.containerNo }}
                          </td>
                          <td
                            @click="viewEdit(item.ffExecutionContainerId, index)"
                            class="showMoreData"
                          >
                            {{ item.containerType }}
                          </td>

                          <td>
                            {{ item.customSealNo != "" ? item.customSealNo : "--" }}
                          </td>
                          <td>
                            {{ item.LineSealNo != "" ? item.LineSealNo : "--" }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- /.box-body -->
                </div>

                <b-card
                  class="mt-3"
                  style="background: whiteSmoke"
                  v-if="
                    getContainerList.length > 0 ||
                    ContainerTypeSizefactory.ffExecutionContainerId != ''
                  "
                >
                  <div
                    class="gutr"
                    v-if="
                      getContainerList.length > 0 ||
                      ContainerTypeSizefactory.ffExecutionContainerId != ''
                    "
                  >
                    <!-- <md-layout md-gutter>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="95">
                        <label>
                          <b>
                            <u>
                              Container Details
                              <span
                                class="error"
                                v-if="containerTypeDetailFactory.length==0"
                              >{{errorAtleastContainer}}</span>
                            </u>
                          </b>
                        </label>
                      </md-layout>
                    </md-layout> -->

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="45">
                        <label
                          v-if="ContainerTypeSizefactory.ffExecutionContainerId == ''"
                          >Container Type/Size</label
                        >
                        <model-list-select
                          v-if="ContainerTypeSizefactory.ffExecutionContainerId == ''"
                          option-value="containerTypeId"
                          option-text="containerType"
                          :list="ContainerTypeList"
                          placeholder="Select  Type/Size"
                          v-model="ContainerTypeSizefactory.containerTypeId"
                        ></model-list-select>
                        <md-layout md-flex="100" v-else>
                          <label for="containerType">Container Type/Size</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            v-model="ContainerTypeSizefactory.containerType"
                            disabled
                          ></b-form-input>
                        </md-layout>
                        <span
                          class="error"
                          v-if="!ContainerTypeSizefactory.containerTypeId"
                          >{{ errorContainer.containerTypeId }}</span
                        >
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="50">
                        <md-layout md-flex="100">
                          <label>Container No.(eg. AAAA1234567) *</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="containerNo"
                            v-model="ContainerTypeSizefactory.containerNo"
                            @keyup="containerNoRegexfun"
                          ></b-form-input>
                        </md-layout>
                        <span
                          class="error"
                          v-if="!ContainerTypeSizefactory.containerNo"
                          >{{ errorContainer.containerNo }}</span
                        >
                        <span class="error" v-else-if="containerNoRegexError != ''">{{
                          containerNoRegexError
                        }}</span>
                        <span
                          class="error"
                          v-if="
                            containerNoRegexError == '' &&
                            ContainerTypeSizefactory.containerNo != '' &&
                            ContainerTypeSizefactory.containerNo != algoConNo &&
                            showAlgo == true
                          "
                          >Note:System Generated Container No. is : {{ algoConNo }}</span
                        >
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="50"></md-layout>
                      <md-layout md-flex="15">
                        <md-layout md-flex="100">
                          <label>Net Wgt.</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="netWeight"
                            name="netWeight"
                            type="number"
                            min="0"
                            v-model="ContainerTypeSizefactory.netWeight"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="10">
                        <md-layout md-flex="100">
                          <label>Gross Wgt *</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="grossWeight"
                            name="grossWeight"
                            type="number"
                            min="0"
                            v-model="ContainerTypeSizefactory.grossWeight"
                          ></b-form-input>
                        </md-layout>

                        <span
                          class="error"
                          v-if="!ContainerTypeSizefactory.grossWeight"
                          >{{ errorContainer.grossWeight }}</span
                        >
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="15">
                        <label for="weightUnit">Unit</label>
                        <model-list-select
                          :list="unitList"
                          option-value="uV"
                          option-text="uT"
                          placeholder="Select Unit"
                          name="weightUnit"
                          id="weightUnit"
                          v-model="ContainerTypeSizefactory.weightUnit"
                        ></model-list-select>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="15">
                        <label>Handover Date</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          :minute-step="1"
                          name="handoverDate"
                          id="handoverDate"
                          v-model="ContainerTypeSizefactory.handoverDate"
                        ></date-picker>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Custom Seal No.</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="customSealNo"
                            name="customSealNo"
                            v-model="ContainerTypeSizefactory.customSealNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Line Seal No.</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="LineSealNo"
                            name="LineSealNo"
                            v-model="ContainerTypeSizefactory.LineSealNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>Container Tare Wgt</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="tareWeight"
                            name="tareWeight"
                            type="number"
                            min="0"
                            v-model="ContainerTypeSizefactory.tareWeight"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="15">
                        <md-layout md-flex="100">
                          <label>Measurement (in CBM)</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="noOfpkgUnit"
                            id="noOfpkgUnit"
                            type="number"
                            min="0"
                            v-model="ContainerTypeSizefactory.measurement"
                          ></b-form-input>
                          <!-- <span
                    class="error"
                    v-if="!ContainerTypeSizefactory.measurement"
                          >{{errorContainer.measurement}}</span>-->
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <label>Package Details *</label>
                        <model-list-select
                          :list="packageNameList"
                          id="clientId"
                          v-model="ContainerTypeSizefactory.packageId"
                          option-value="packageId"
                          option-text="packageName"
                          placeholder="Select  Package Name"
                        ></model-list-select>

                        <span class="error" v-if="!ContainerTypeSizefactory.packageId">{{
                          errorContainer.packageId
                        }}</span>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label
                            >No. of Packages ({{ ContainerTypeSizefactory.packageName }})
                            *</label
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="noOfpkgUnit"
                            id="noOfpkgUnit"
                            type="number"
                            min="0"
                            :disabled="
                              ContainerTypeSizefactory.packageName == '' ? true : false
                            "
                            v-model="ContainerTypeSizefactory.noOfpkgUnit"
                          ></b-form-input>
                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.noOfpkgUnit"
                            >{{ errorContainer.noOfpkgUnit }}</span
                          >
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>Cargo Stuffing Date</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          name="cargoStuffingDate"
                          id="cargoStuffingDate"
                          v-model="ContainerTypeSizefactory.cargoStuffingDate"
                          :minute-step="1"
                        ></date-picker>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <!-- <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>LEEO (Let Export Permit) Date</label>
                        <date-picker
                          lang="en"
                          name="leeoDate"
                          id="leeoDate"
                          v-model="ContainerTypeSizefactory.leeoDate"
                          :minute-step="1"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>LEEO (Let Export Permit) No.</label>
                          <b-form-input :formatter="capitalizeAll"
                            name="leeoNo"
                            id="leeoNo"
                            v-model="ContainerTypeSizefactory.leeoNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>-->
                      <md-layout md-flex="85"></md-layout>
                      <md-layout md-flex="15">
                        <b-button
                          class="mt-2 pull-right"
                          variant="info"
                          size="sm"
                          id="addButtonLoaderfactory"
                          @click="factoryStuffingContainer"
                          >{{
                            editIndex == "" &&
                            (editIndex != 0 || editIndex != "0") &&
                            ContainerTypeSizefactory.ffExecutionContainerId == ""
                              ? "Add"
                              : "Edit"
                          }}
                          Container</b-button
                        >
                        <md-spinner
                          md-indeterminate
                          id="loaderfactory"
                          style="display: none"
                        ></md-spinner>
                      </md-layout>
                    </md-layout>
                  </div>

                  <md-layout md-gutter v-if="showDivCountNote" style="margin-top: 1%">
                    <md-layout md-flex="10">
                      <label>
                        <b>
                          <u class="error">Please Add</u>
                        </b>
                      </label>
                    </md-layout>
                    <md-layout md-flex="85" v-if="containerCountWise.length > 0">
                      <div v-for="(type1, index) in containerCountWise" :key="index">
                        <md-chip style="margin-right: 4px" v-if="type1.totalCount != 0">
                          <span v-if="type1.totalCount != 0" style="color: #0e0052"
                            >{{ type1.containerType }} -</span
                          >
                          <span v-if="type1.totalCount != 0" style="color: red"
                            >{{ type1.totalCount }} Left</span
                          >
                        </md-chip>
                      </div>
                    </md-layout>
                  </md-layout>
                </b-card>
              </div>
            </div>
            <div>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="20">
                  <label>VGM Submission Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    name="vgmSubmissionDate"
                    id="vgmSubmissionDate"
                    v-model="WarehouseStuffing.vgmSubmissionDate"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="gateInDate">SI Submission date</label>
                  <date-picker
                    lang="en"
                    id="gateInDate"
                    type="datetime"
                    format="YYYY-MM-DD hh:mm a"
                    :minute-step="1"
                    name="gateInDate"
                    v-model="WarehouseStuffing.siSubmissionDate"
                  ></date-picker>
                  <!-- <span class="error" v-if="!factoryStuffing.gateInDate">{{errorExecution.gateInDate}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="trSubmissionDate">TR Submission date</label>
                  <date-picker
                    lang="en"
                    id="trSubmissionDate"
                    type="datetime"
                    format="YYYY-MM-DD hh:mm a"
                    :minute-step="1"
                    name="trSubmissionDate"
                    v-model="WarehouseStuffing.trSubmissionDate"
                  ></date-picker>
                  <span class="error" v-if="WarehouseStuffing.trSubmissionDate_err">{{
                    WarehouseStuffing.trSubmissionDate_err
                  }}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>Handover Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    name="handoverDate"
                    id="handoverDate"
                    v-model="WarehouseStuffing.handoverDate"
                    :minute-step="1"
                  ></date-picker>
                  <span class="error" v-if="WarehouseStuffing.handoverDate_err">{{
                    WarehouseStuffing.handoverDate_err
                  }}</span>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label for="gateInDate">Gate-In date time</label>
                    <date-picker
                      :disabled="WarehouseStuffing.vgmSubmissionDate==''"
                      lang="en"
                      id="gateInDate"
                      type="datetime"
                      format="YYYY-MM-DD hh:mm a"
                      :minute-step="1"
                      name="gateInDate"
                      v-model="WarehouseStuffing.gateInDate"
                    ></date-picker>
                    <span class="error" v-if="!factoryStuffing.gateInDate">{{errorExecution.gateInDate}}</span> 
                  </md-layout>
                </md-layout>-->
              <md-layout md-gutter class="labelMargtop"> </md-layout>
              <md-layout class="gutr" gutter v-if="ffExportDetail.portType == 'Icd'">
                <md-layout md-flex="25">
                  <label>
                    <u>Custom Clearance</u>
                  </label>
                </md-layout>
              </md-layout>

              <md-layout
                md-gutter
                class="labelMargtop"
                v-if="ffExportDetail.portType == 'Icd'"
              >
                <md-layout md-flex="20">
                  <label for="custmClearByPridel">CC to be done by Pridel</label>

                  <model-list-select
                    :list="CCList"
                    v-model="WarehouseStuffing.custmClearByPridel"
                    option-value="ccInfoVal"
                    option-text="ccInfoText"
                    placeholder="Select"
                  ></model-list-select>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>CC Assignment No.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      name="ccAsignmentNo"
                      id="ccAsignmentNo"
                      v-model="WarehouseStuffing.ccAsignmentNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <div>
                <b-button
                  class="mt-3 smbutnWidth"
                  variant="primary"
                  @click="addFactoryExecution('SAVE')"
                  id="addButtonLoaderVGM"
                  >Save & Submit</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loaderVGM"
                  style="display: none"
                ></md-spinner>
              </div>

              <!-- <md-layout md-gutter v-if="ffExportDetail.mergeffExportId!='0'">
                  <md-layout md-flex="5"></md-layout>
                  <h4 style="color:green;letter-spacing:1px">
                    Note : Your B/L is merge with this
                    <u>{{ffExportDetail.mergeSeries}}</u>
                  </h4>
                </md-layout> -->
              <div
                v-if="
                  (proceedFurther == true && sbDetailArrayList.length > 0) ||
                  newContainerFlow == '1'
                "
              >
                <div
                  md-gutter
                  v-if="getContainerList.length == 0 || newContainerFlow == '1'"
                >
                  <b-button
                    class="mt-1"
                    variant="primary"
                    @click="addFactoryExecution('VGM')"
                    id="addButtonLoaderVGM"
                    >Save & Proceed To VGM</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loaderVGM"
                    style="display: none"
                  ></md-spinner>
                </div>
                <div
                  md-gutter
                  v-if="getContainerList.length == 0 || newContainerFlow == '1'"
                >
                  <!-- <b-button
                      class="mt-1"
                      variant="primary"
                      @click="addFactoryExecution('PAY')"
                      id="addButtonLoaderVGM"
                      >Save & Proceed To S-Line Payment</b-button
                    >
                    <md-spinner
                      md-indeterminate
                      id="loaderVGM"
                      style="display: none"
                    ></md-spinner><br /> -->
                  <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" -->
                  <b-button
                    class="mt-1"
                    variant="primary"
                    @click="addFactoryExecution('PAYTEST')"
                    id="addButtonLoaderVGM"
                    >Save & Proceed To S-Line Payment</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loaderVGM"
                    style="display: none"
                  ></md-spinner>
                  <br />
                </div>
                
                <div
                  md-gutter
                  v-if="getContainerList.length == 0 || newContainerFlow == '1'"
                >
                  <b-button
                    class="mt-1"
                    v-if="(!ffExportDetail.mergeffExportId || ffExportDetail.mergeffExportId == '0')"
                    variant="primary"
                    @click="addFactoryExecution('BLRaised')"
                    id="addButtonLoaderBL"
                    >Save & Proceed to Raise B/L</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loaderBL"
                    style="display: none"
                  ></md-spinner>
                </div>
                <div
                  md-gutter
                  v-if="getContainerList.length == 0 || newContainerFlow == '1'"
                >
                  <b-button
                    class="mt-1"
                    variant="primary"
                    @click="addFactoryExecution('handover')"
                    id="addButtonLoaderRail"
                    >{{
                      ffExportDetail.portType == "Icd"
                        ? "Save & Proceed to Handover to Rail"
                        : "Save & Proceed to Gate ­ in at Terminal By Road"
                    }}</b-button
                  >
                  <!-- {{ffExportDetail.portType=='Icd'?"Save & Proceed to Handover to Rail":"Save & Proceed to Gate ­ in at Terminal By Road"}} -->
                  <md-spinner
                    md-indeterminate
                    id="loaderRail"
                    style="display: none"
                  ></md-spinner>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose7"
      ref="addPop7"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
      @close="onClose"
    ></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import ContainerComponent from "../allModuleForm/containerComponent.vue";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editExportFCLId") != undefined &&
      this.$sessionsStorage.get("editExportFCLId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/ffexecutionWareHouse");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo = newVal.containerNo.toUpperCase();

          if (this.ContainerTypeSizefactory.packageId != "") {
            let arrayNew = this.packageNameList.filter((x) => {
              return x.packageId == this.ContainerTypeSizefactory.packageId;
            });

            if (arrayNew.length > 0) {
              this.ContainerTypeSizefactory.packageName = arrayNew[0].packageName;
            }
          }
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      ON_Type: "",
      ffSlinePayId: "",
      selectDateFormat,
      visible: true,
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],

      CCList: [
        {
          ccInfoVal: "Yes",
          ccInfoText: "Yes",
        },
        {
          ccInfoVal: "No",
          ccInfoText: "No",
        },
      ],
      getContainerList: [],
      mainEntryData: [],
      ALLMODULE: "",
      JOBSERIES: "",
      getLocationList: [],
      ffExportDetail: {
        clientName: "",
        ffExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
      },

      SBDetail: {
        shippingSBId: "",
        shippingBillDate: "",
        shippingBillNo: "",
        cargoGrossWeight: "",
        invoiceUpload: "",
        cargoUpload: "",
        shippingInvoiceNo: "",
        shippingInvoiceDate: "",
        shippingBillUpload: "",
      },

      errorSBExecution: {
        shippingBillDate: "",
        shippingBillNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        vgmSubmissionDate: "",
        gateInDate: "",
        siSubmissionDate: "",
        trSubmissionDate: "",
        handoverDate: "",

        vgmSubmissionDate_err: "",
        siSubmissionDate_err: "",
        trSubmissionDate_err: "",
        handoverDate_err: "",

        ffExecutionId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),

        stuffingType: "",
        portType: "",

        nameOfCFS: "",
        cartingDate: "",
        crnNumber: "",

        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
      },
      permissionStatus: true,
      sbDetailArray: [],
      showMoreSB: false,

      errorExecution: {
        // cartingDate: "",
        // crnNumber: ""
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        netWeight: "",
        weightUnit: "",
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },

      removeContainerVmodel: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
      packageNameList: [],
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //    measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight1",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      ContainerFromTPT: [],
      newContainerFlow: null,
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      BookingShippingLine: {
        assignmentNumber: "",
        bookingNumber: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "",
        stuffingType: "",
        vesselEta: "",
        vesselEtd: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        voyageNo: "",
      },
      validateTrans: true,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
     CustomLoader,
    DocForm,
    ContainerComponent,
    BannerComponent,
  },
  computed: {
    proceedFurther() {
      if (this.containerTypeDetailFactory.length > 0) {
        let arrayG = this.containerTypeDetailFactory.filter((x) => {
          return x.containerNo;
        });

        return arrayG.length == this.containerTypeDetailFactory.length ? true : false;
      } else {
        return false;
      }
    },
    viewInvoicedDoc() {
      return this.SBDetail.invoiceUpload != ""
        ? this.SBDetail.invoiceUpload.split(",")
        : [];
    },
    viewShippingdDoc() {
      return this.SBDetail.shippingBillUpload != "" &&
        this.SBDetail.shippingBillUpload != null
        ? this.SBDetail.shippingBillUpload.split(",")
        : [];
    },
    viewCargoDoc() {
      return this.SBDetail.cargoUpload != "" ? this.SBDetail.cargoUpload.split(",") : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    onFileChange(ID) {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("moduleId", this.$sessionsStorage.get("editExportFCLId"));
        if (ID == "Invoice") {
          formData.append("staticFileName", "Sea_Export_Ware_ShipperInvoice");
        } else if (ID == "Cargo") {
          formData.append("staticFileName", "Sea_Export_Ware_Cargolist");
        } else {
          formData.append("staticFileName", "Sea_Export_Ware_ShippingBill");
        }

        //  formData.append("upload_dir_folderName", "FF_Sea_Export_Uploads");
        formData.append(
          "upload_dir_folderName",
          this.mainEntryData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "Invoice") {
            this.SBDetail.invoiceUpload = result.data;
          } else if (ID == "Cargo") {
            this.SBDetail.cargoUpload = result.data;
          } else {
            this.SBDetail.shippingBillUpload = result.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
      }
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let shipperInvoiceNoArry = [];
        let containerNoArry = [];
        let customSealNoArry = [];
        let lineSealNoArry = [];
        let shippingBillNoArry = [];
        let shippingBillDateArry = [];

        this.sbDetailArray.map((x) => {
          shipperInvoiceNoArry.push(x.shippingInvoiceNo);
          shippingBillNoArry.push(x.shippingBillNo);
          shippingBillDateArry.push(x.shippingBillDate);
        });

        this.containerTypeDetailFactory.map((x) => {
          containerNoArry.push(x.containerNo);
          customSealNoArry.push(x.customSealNo);
          lineSealNoArry.push(x.LineSealNo);
        });

        let newData = {
          mail: "FF",
          clientName: this.ffExportDetail.clientName,
          assignmentNo: this.ffExportDetail.ffExportFclSeries,
          POR: this.ffExportDetail.POR,
          FinalPlace: this.ffExportDetail.FinalPlace,
          shippingLine: this.ffExportDetail.shippingLine,
          wareHouseExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
          ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
          containerNoArry: containerNoArry,
          lineSealNoArry: lineSealNoArry,
          customSealNoArry: customSealNoArry,
          shipperInvoiceNoArry: shipperInvoiceNoArry,
          sLineBookingNo: this.BookingShippingLine.bookingNumber,
          vesselName: this.BookingShippingLine.vesselName,
          voyyageNo: this.BookingShippingLine.voyageNo,
          suCutoff: this.BookingShippingLine.SICutOff,
          noOfContainers: containerNoArry.length,
          shippingBillDateArry: shippingBillDateArry,
          shippingBillNoArry: shippingBillNoArry,
        };

        if (this.validate != false) {
          $("#addButtonLoaderS").css("display", "none");
          $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/sendExecutionDetailsToClient.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");

              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    openPop() {
      this.alert.content = "Send Assignment Details To Client ..?";
      this.$refs["popMail"].open();
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
      // if (this.ffExportDetail.containerInfo == "lcl") {
      //   this.$router.push({
      //     path: "/freightForward/ffExportFcl",
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffBooking",
      //   });
      // }
    },
    onFileChangeInvoice() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionInvoiceSBWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.invoiceUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    onFileChangeShipping() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionShipUpWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.shippingBillUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    onFileChangeCargo() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionCargoSBWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.cargoUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    onClose(type) {
      this.$sessionsStorage.set("editSalesExId", "");
      this.$sessionsStorage.set("editSalesExId", this.ALLMODULE);
      if (type != "cancel") {
        if (
          // this.ffExportDetail.portType == "Icd" &&
          this.nextPageType == "handover"
        ) {
          this.$router.push({
            path: "/freightForward/handoverToRail",
          });
        } else if (this.nextPageType == "VGM") {
          this.$router.push({
            path: "/freightForward/vgmDetail",
          });
        } else if (this.nextPageType == "BLRaised") {
          this.$router.push({
            path: "/freightForward/fclBLofLanding",
          });
        } else if (this.nextPageType == "PAY") {
          this.$router.push({
            path: "/freightForward/ffSLinePaymentExport",
          });
        } else if (this.nextPageType == "PAYTEST") {
          if (
            this.ON_Type == "New" ||
            this.ffSlinePayId == "" ||
            this.ffSlinePayId == undefined
          ) {
            this.$router.push({
              path: "/freightForward/ffSLinePaymentExportN_VP",
              // path: "/freightForward/ffSLinePaymentExportNew",
            });
          } else {
            this.$router.push({
              path: "/freightForward/ffSLinePaymentExport",
            });
          }
        }
      }
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_execution_container",
          tableId: "ffExecutionContainerId",
          isActive: "isActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();
              this.deleteId = "";
            }
          })
          .catch((error) => {});
      }
    },
    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },

    DeleteListSb(id, index) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop7"].open();
    },
    addSBDetail() {
      this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.invoiceUpload) {
        let obj = {
          allModuleId: this.ALLMODULE,
          docName: "FF_SEA_EX_SHIPPER_INVOICE",
          docLink: this.SBDetail.invoiceUpload,
        };
        this.SBDetail.uploadArray.push(obj);
      }
      if (this.SBDetail.cargoUpload) {
        let obj1 = {
          allModuleId: this.ALLMODULE,
          docName: "BL_LINEINVOICEREQ",
          docLink: this.SBDetail.cargoUpload,
        };
        this.SBDetail.uploadArray.push(obj1);
      }
      if (this.SBDetail.shippingBillUpload) {
        let obj2 = {
          allModuleId: this.ALLMODULE,
          docName: "FF_SEA_EX_SB",
          docLink: this.SBDetail.shippingBillUpload,
        };
        this.SBDetail.uploadArray.push(obj2);
      }
      let new_data = {
        SBDetail: this.SBDetail,
        WarehouseStuffing: this.WarehouseStuffing,
      };

      this.validateSBDetail();
      if (this.validateSB != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addSBWareHouseExecution.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editFFExecutionId", data.ffExecutionId);
              this.WarehouseStuffing.ffExecutionId = data.ffExecutionId;
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }

              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = "";
              });
              Object.keys(this.errorSBExecution).map((x) => {
                this.errorSBExecution[x] = "";
              });
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    validateExecution() {
      let validate_new = true;
      // Object.keys(this.errorExecution).map((x, index) => {
      //   if (this.WarehouseStuffing[x] == "") {
      //     this.errorExecution[x] = this.arrayExecutionError[index];
      //     validate_new = false;
      //   }
      // });

      if (
        this.WarehouseStuffing.nameOfCFS == "" &&
        this.WarehouseStuffing.portType == "Icd"
      ) {
        this.nameOfCFSError = "Enter name of CFS";
      } else {
        this.nameOfCFSError = "";
      }

      if (this.containerTypeDetailFactory.length == 0) {
        this.errorAtleastContainer = "Select Atleast one Container";

        validate_new = false;
      } else {
        this.errorAtleastContainer = "";
      }

      if (this.sbDetailArrayList.length == 0) {
        this.showMoreSB = true;
        this.errorAtleastSb = "Select Atleast one Shipping Details";
        validate_new = false;
      } else {
        this.showMoreSB = false;
        this.errorAtleastSb = "";
      }

      if (validate_new == false) {
        if (this.errorAtleastContainer == "") {
          window.scroll(0, 50);
        }

        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    addFactoryExecution(id) {
      this.nextPageType = id;
      if (this.newContainerFlow == "0") {
        this.validateExecution();
      }

      // if (
      //   this.nextPageType == "handover" &&
      //   (this.WarehouseStuffing.gateInDate == "" ||
      //     this.WarehouseStuffing.vgmSubmissionDate == "")
      // ) {
      //   this.alert.content =
      //     "VGM Submission Date and Gate-In Date must be entered before proceeding to Handover";
      //   this.$refs["addPop"].open();
      //   return false;
      // }

      if (this.validateTrans != false) {
        if (id == "handover") {
          $("#addButtonLoaderRail").css("display", "none");
          $("#loaderRail").css("display", "block");
        }
        if (id == "BLRaised") {
          $("#addButtonLoaderBL").css("display", "none");
          $("#loaderBL").css("display", "block");
        }
        if (id == "VGM") {
          $("#addButtonLoaderVGM").css("display", "none");
          $("#loaderVGM").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addWareHouseExecution.php`,
          data: JSON.stringify(this.WarehouseStuffing),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editFFExecutionId", data.ffExecutionId);
              this.WarehouseStuffing.ffExecutionId = data.ffExecutionId;
              if (id == "handover") {
                $("#loaderRail").css("display", "none");
                $("#addButtonLoaderRail").css("display", "block");
              }
              if (id == "BLRaised") {
                $("#loaderBL").css("display", "none");
                $("#addButtonLoaderBL").css("display", "block");
              }
              if (id == "VGM") {
                $("#loaderVGM").css("display", "none");
                $("#addButtonLoaderVGM").css("display", "block");
              }
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                // this.$refs["addPop2"].open();
                if (
                  this.WarehouseStuffing.vgmSubmissionDate &&
                  this.WarehouseStuffing.siSubmissionDate &&
                  this.WarehouseStuffing.trSubmissionDate &&
                  this.WarehouseStuffing.handoverDate
                ) {
                  this.$refs["addPop2"].open();
                }
              }
              if (this.nextPageType == "SAVE") {
                this.getData();
              }

              if (
                id == "BLRaised" ||
                id == "handover" ||
                id == "VGM" ||
                id == "PAYTEST"
              ) {
                if (!this.WarehouseStuffing.vgmSubmissionDate) {
                  this.WarehouseStuffing.vgmSubmissionDate_err =
                    "Please Enter VGM Submission Date";
                }
                if (!this.WarehouseStuffing.siSubmissionDate) {
                  this.WarehouseStuffing.siSubmissionDate_err =
                    "Please Enter SI Submission Date";
                }
                if (!this.WarehouseStuffing.trSubmissionDate) {
                  this.WarehouseStuffing.trSubmissionDate_err =
                    "Please Enter TR Submission Date";
                }
                if (!this.WarehouseStuffing.handoverDate) {
                  this.WarehouseStuffing.handoverDate_err = "Please Enter Handover Date";
                }
              }
            }
          })
          .catch((error) => {});
      }
    },

    validateContainer() {
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      let validate_new = true;
      Object.keys(this.errorContainer).map((x, index) => {
        if (
          this.ContainerTypeSizefactory[x] == "" ||
          this.ContainerTypeSizefactory[x] == null
        ) {
          this.errorContainer[x] = this.arrayContainerError[index];
          validate_new = false;
        }
      });

      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
        validate_new = false;
      } else if (containerformat.test(this.ContainerTypeSizefactory.containerNo)) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
        validate_new = false;
      }

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );
      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (containerformat.test(this.ContainerTypeSizefactory.containerNo)) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    factoryStuffingContainer() {
      if (this.getContainerList.length > 0) {
        let array_new = this.getContainerList;
        if (this.ContainerTypeSizefactory.containerTypeId != "") {
          let new_array = array_new.filter((x) => {
            return x.containerTypeId == this.ContainerTypeSizefactory.containerTypeId;
          });

          if (new_array.length > 0) {
            this.ContainerTypeSizefactory.containerType = new_array[0].containerType;
          }
        }
      }

      let new_data = {
        ContainerTypeSizefactory: this.ContainerTypeSizefactory,
        WarehouseStuffing: this.WarehouseStuffing,
      };

      this.validateContainer();

      if (this.validateTrans != false) {
        $("#addButtonLoaderfactory").css("display", "none");
        $("#loaderfactory").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addWareHouseContainer.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editFFExecutionId", data.ffExecutionId);
              this.WarehouseStuffing.ffExecutionId = data.ffExecutionId;
              $("#loaderfactory").css("display", "none");
              $("#addButtonLoaderfactory").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });

              Object.keys(this.errorContainer).map((x) => {
                this.errorContainer[x] = "";
              });

              this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    DeleteList(id, index) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ffExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
    },

    onClose7(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_execution_sb",
          tableId: "shippingSBId",
          isActive: "isAcitveSB",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data.clientId != "" && status == 200 && data) {
              // this.JqueryFun();
              this.getData();
              this.deleteId = "";
            }
          })
          .catch((error) => {});
      }
    },

    viewEditSB(id, index) {
      let array = this.sbDetailArray.filter((x) => {
        return x.shippingSBId == id;
      });

      Object.keys(this.SBDetail).map((x) => {
        this.SBDetail[x] = array[0][x];
      });
    },
    getData() {
      this.doLoading();
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        exPage: "1",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId:
          this.$sessionsStorage.get("editFFBookingId") != "" &&
          this.$sessionsStorage.get("editFFBookingId") != undefined
            ? this.$sessionsStorage.get("editFFBookingId")
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewFFBookingDetails_NewV3.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.newContainerFlow.length > 0) {
              this.newContainerFlow = data.newContainerFlow;
            } else {
              this.newContainerFlow = "";
            }
            if (data.ContainerFromTPT.length > 0) {
              if (!this.$sessionsStorage.get("editFFExecutionId")) {
                this.$sessionsStorage.set("editFFExecutionId", data.autoExecutionId);
              }
              this.ContainerFromTPT = data.ContainerFromTPT;

              if (data.ContainerFromTPT[0].ContainerNumber != null) {
                this.ContainerNoTPT = data.ContainerFromTPT[0].ContainerNumber.split(",");
              }
              if (data.ContainerFromTPT[0].ContainerType.length > 0) {
                this.ContainerNoTypeTPT = data.ContainerFromTPT[0].ContainerType.split(
                  ","
                );
              }
              this.conDetailsTPT =
                data.ContainerFromTPT[0].ContainerType +
                "\n" +
                data.ContainerFromTPT[0].ContainerNumber;
            }

            this.getLocationList = data.portLocationArray;

            if (data.containerCountWise.length > 0) {
              this.containerCountWise = data.containerCountWise;
              let array_new = this.containerCountWise.map((x) => {
                if (x.totalCount == 0) {
                  this.showDivCountNote = false;
                } else {
                  this.showDivCountNote = true;
                  return false;
                }
              });
            }

            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            if (data.ffBookingDetail.length > 0) {
              Object.keys(data.ffBookingDetail[0]).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }

            if (data.editFFEX.length > 0) {
              this.mainEntryData = data.editFFEX;

              this.WarehouseStuffing.portType = data.editFFEX[0].portType;
              this.WarehouseStuffing.stuffingType = data.editFFEX[0].stuffingType;
              this.WarehouseStuffing.containerInfo = data.editFFEX[0].containerInfo;
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });
              this.ALLMODULE = data.editFFEX[0].allModuleId;
              this.JOBSERIES = data.editFFEX[0].ffExportFclSeries;
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }

            if (
              this.$sessionsStorage.get("editFFExecutionId") != "" &&
              this.$sessionsStorage.get("editFFExecutionId") != undefined
            ) {
              this.viewExecutionDetail();
            } else {
              this.doLoadingClose();
            }
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    viewExecutionDetail() {
      this.doLoading();
      // alert(this.ALLMODULE);
      let new_data = {
        allModuleID: this.ALLMODULE,
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        newData: this.ffExportDetail,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewExecutionDetail.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.ffExecutionDetail.length > 0) {
              Object.keys(this.WarehouseStuffing).map((x) => {
                this.WarehouseStuffing[x] = data.ffExecutionDetail[0][x] || "";
              });
            }
            this.ON_Type = data.ffseaType;
            this.ffSlinePayId = data.ffSlinePayId;
            // alert(data.ffseaType);
            console.log("ffseaType_query=>", data.ffseaType_query);
            console.log("ffseaType=>", data.ffseaType);

            if (data.ffExecutionDetailContainer.length > 0) {
              this.containerTypeDetailFactory = data.ffExecutionDetailContainer;

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ffExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ffSBDetail.length > 0) {
              this.sbDetailArray = data.ffSBDetail;
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffExecutionWareHouse.vue?5520ec5b